






import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    PdCreateForm: () => import('@/components/pd/PdCreateForm.vue')
  }
})
export default class PdTabCreateInapp extends Vue {
  @Prop(Number) patientId!: number

  get user() {
    return this.$store.getters['user/userInfo']
  }

  async created() {
    await this.checkIsValidLogin()
    this.$store.dispatch('pd/setIsInAppBrowser', true)
    this.$router.replace({
      name: 'PdTabCreate',
      params: { patientId: String(this.patientId) }
    })
  }

  async checkIsValidLogin() {
    try {
      await this.$api.user.fetch()
    } catch (e) {
      this.$store.dispatch('alert/showErrorMessages', ['エラーが発生しました'])
      this.$router.replace({ name: 'Hangup' })
    }
  }
}
